import React from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//CSS
import './style.css';
export default function Features(props){
    return(
        <section id={props.id} className="imageblock-section switchable switchable-content">
            <Col md={4} lg={5} className="imageblock-section-img">
                <div className="background-image-holder" style={{marginLeft: '-3rem', backgroundImage:`url(${props.image})`}}></div>
            </Col>
            <Container>
                <Row>
                    <Col md={7} lg={6}>
                        <Row className="align-items-center pt-5 pb-5">
                            <Col lg={12}>
                                {props.featuresList.map((item, i)=>
                                    <div className="d-flex align-items-start mb-5" key={i}>
                                        <div className="pr-4">
                                            <div className={`icon icon-shape rounded-circle icon-color-${i+1}`}>
                                                <span><FontAwesomeIcon icon={item.icon}/></span>
                                            </div>
                                        </div>
                                        <div className="icon-text">
                                            <h5>{item.title}</h5>
                                            <p className="mb-0">{item.text}</p>
                                        </div>
                                    </div>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}